import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";

class DropdownSimple extends React.Component {

    render() {
			const {options, input:{onChange, value}} = this.props
      return (
					<select style={{padding:'1.5px 0', width: '100%'}} value={value || ''} onChange={onChange}>
						<option key={-1} value={''} disabled></option>
						{
							options.map((item)=>(
									<option key={item.value} value={item.value}>{item.label}</option>
							))
						}
					</select>
      )  
    }
}

DropdownSimple.propTypes = {
    options: PropTypes.array.isRequired,
		//placeholder: PropTypes.string.isRequired,
};

export default withStyles(styles)(DropdownSimple)


// WEBPACK FOOTER //
// ./src/views/Components/DropdownSimple.jsx